<section class="text-center mb-3">
  <div class="navbar mb-3">
    <p class="section-title-revisione latopers" style="width: 100%">
      VERBALE {{ ragione_sociale }}
    </p>

    <div class="display-flex-center w-100 p-2">
      <button class="btn btn-primary me-2" (click)="goToFascicolo()">Fascicolo</button>
      <button class="btn btn-primary me-3" (click)="getVerbalePrec()">Verbale precedente</button>
      <app-carica-da-pc class="m-1"></app-carica-da-pc>
      <app-salva-su-server></app-salva-su-server>
      <a routerLink="gestione-stampe" routerLinkActive="disabled" class="btn btn-primary ms-3 me-1"> <i
        class="bi bi-printer-fill"></i> Gestione stampe </a>
      <app-invia-verbale class="ms-3"></app-invia-verbale>
    </div>
    <div class="display-flex-center w-100 p-2" *ngIf="testingMode">
      <input #fileInput type="file" (change)="importVerbale($event)" style="display:none;" accept=".xml"/>
      <button class="btn btn-warning me-2" (click)="fileInput.click()">Import revisione TESTING</button>
      <button class="btn btn-warning me-3" (click)="export()">Export revisione TESTING</button>
    </div>
  </div>

  <div *ngIf="settling$ | async" class="text-muted small mb-2">
    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
    Validazione in corso…
  </div>

  <div class="revisione-sections-container">
    <div class="mb-3">
      <div class="w-100 d-flex gap-3 align-items-center justify-content-center flex-wrap">
        <app-nav-link-status-btn *ngFor="let navbarLink of navbarLinksRilevazione" [navbarLink]="navbarLink" [loading]="settling$ | async"></app-nav-link-status-btn>
      </div>
    </div>
    <div class="mb-3">
      <div class="w-100 d-flex gap-3 align-items-center justify-content-center flex-wrap">
        <button
          *ngFor="let navbarLink of navbarLinksAccertamento"
          type="button"
          class="btn btn-secondary"
          [disabled]="navbarLink.isDisabled$ | async"
          [routerLink]="navbarLink.path"
          routerLinkActive="disabled"
          queryParamsHandling="merge"
        >
          <i class="bi bi-lock-fill me-1"></i>{{ navbarLink.title }}
        </button>
      </div>
    </div>
    <div class="mb-3">
      <div class="w-100 d-flex gap-3 align-items-center justify-content-center flex-wrap">
        <app-nav-link-status-btn *ngFor="let navbarLink of navbarLinksSchedaSettore" [navbarLink]="navbarLink" [loading]="settling$ | async"></app-nav-link-status-btn>
      </div>
    </div>
  </div>

  <div class="nav-bottom z-999">
        <span (click)="navigationWithArrows(false)" title="Scheda precedente">
            <i id="prev" class="bi bi-arrow-left-circle-fill custom-font me-2"></i>
        </span>
    <span (click)="navigationWithArrows(true)" title="Scheda successiva">
            <i id="next" class="bi bi-arrow-right-circle-fill custom-font"></i>
        </span>
  </div>
</section>
<app-form-errors-debug></app-form-errors-debug>

<ngx-smart-modal [identifier]="importModalId" #importModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-bottom">
        <h5 class="modal-title lh-1 mb-2">Import completato con successo</h5>
      </div>
      <div class="modal-body mt-4 mb-3">
        <p>Per completare l'aggiornamento dei dati, la preghiamo di eseguire questi tre passaggi:</p>
        <ul>
          <li>
            nella sezione Contributo biennale, premere «Calcola contributo» e successivamente «Calcola penalità». Se il contributo risulta già
            compilato (pulsante «Calcola contributo» disabilitato), la sezione resterà segnalata in rosso: è un effetto dell'import, non un errore del verbale;
          </li>
          <li>aprire ciascuna Scheda di settore compilata, in modo che i campi calcolati vengano aggiornati;</li>
          <li>nella sezione Dati bilancio, controllare anche le checkbox.</li>
        </ul>
        <p *ngIf="isOldVersion">
          Il verbale importato proviene da una versione precedente ({{ importedVersion }}): i campi introdotti in seguito potrebbero
          risultare vuoti o da compilare.
        </p>
        <p class="mb-0">Grazie per la collaborazione.</p>
      </div>
      <div class="modal-footer border-top pt-2">
        <button type="button" class="btn btn-primary" (click)="importModal.close()">Chiudi</button>
      </div>
    </div>
  </div>
</ngx-smart-modal>

<ngx-smart-modal [identifier]="updateErrorModalId" #updateErrorModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-bottom">
        <h5 class="modal-title lh-1 mb-2">Problema nei dati del verbale</h5>
      </div>
      <div class="modal-body mt-4 mb-3">
        <p>Il verbale presenta un problema strutturale nei dati: alcuni aggiornamenti dei dati non sono stati applicati e potrebbero non essere salvati.</p>
        <p class="mb-0">Si prega di contattare il supporto tecnico indicando l'ID assegnazione <strong>{{ id_assegnazione }}</strong>.</p>
      </div>
      <div class="modal-footer border-top pt-2">
        <button type="button" class="btn btn-primary" (click)="updateErrorModal.close()">Chiudi</button>
      </div>
    </div>
  </div>
</ngx-smart-modal>
<hr/>
